import React, { Suspense } from 'react';
import { SkeletonMonthLineChart } from '../sekeletons/skeleton-month-line-chart';
import SectionLTVChart from './ltv/section-ltv-chart';
export default function SectionLTV() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "sale mt-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-white p-6 rounded-lg"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement("div", {
            className: "h-[570px] w-full"
        }, /*#__PURE__*/ React.createElement(SkeletonMonthLineChart, null))
    }, /*#__PURE__*/ React.createElement(SectionLTVChart, null))));
}
